<template>
  <div class="serve">
    <!-- 标题 -->
    <div class="title">
      提供专属定制360°全方位服务
    </div>
    <!-- 内容 -->
    <div class="content">
      <div class="item" v-for="(item, index) in serveList" :key="index">
        <!-- 图标 -->
        <div class="img">
          <img :src="item.img" alt="" />
        </div>
        <!-- 内容 -->
        <div class="item-name">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serveList: [
        {
          name: '业务支持',
          img: require('../assets/img/newMarket/serve/01.png')
        },
        {
          name: '技术支持',
          img: require('../assets/img/newMarket/serve/02.png')
        },
        {
          name: '培训支持',
          img: require('../assets/img/newMarket/serve/03.png')
        }
      ]
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.serve {
  width: 1300px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 40px;
  font-weight: 400;
  color: #333333;
  height: 600px;
  .title {
    width: 550px;
    margin: 0 auto;
  }
  .content {
    display: flex;
    justify-content: space-between;
    margin-top: 90px;
    .item {
      width: 208px;
      display: flex;
      flex-direction: column;
      align-items: center;
      // .img:hover {
      //   img {
      //     width: 110%;
      //   }
      // }
      .item-name {
        margin-top: 30px;
      }
    }
  }
}
</style>
